<header><h1>Código de verificación</h1></header>

<div class="container text-center">
<div class="image mt-md-5 mb-4"><img src="" alt=""></div>
  <h2><span>Código incorrecto</span></h2>

    <div class="image"><img src="" alt=""></div>
</div>
